import { render, staticRenderFns } from "./ModalFinanceiroRegraGarantiaMinimaGlobal.vue?vue&type=template&id=1bfb1c1d&scoped=true"
import script from "./ModalFinanceiroRegraGarantiaMinimaGlobal.vue?vue&type=script&lang=ts"
export * from "./ModalFinanceiroRegraGarantiaMinimaGlobal.vue?vue&type=script&lang=ts"
import style0 from "./ModalFinanceiroRegraGarantiaMinimaGlobal.vue?vue&type=style&index=0&id=1bfb1c1d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfb1c1d",
  null
  
)

export default component.exports